import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { spacing } from '@vfuk/core-mixins'

export const CompanyInfo = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${spacing('margin-bottom', 6)}
  `,
)
